import { useCallback, useEffect, useRef, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import { getFilterList, postLikeProducts } from '../../api/product'
import { getSearchCategory } from '../../api/util'
import LikeBtn from '../../components/btn/LikeBtn'
import ProductCenterModal from '../../components/product/ProductCenterModal'
import ProductFilterCenterModal from '../../components/product/ProductFilterCenterModal'
import ProductFilterModal from '../../components/product/ProductFilterModal'
import ProductModal from '../../components/product/ProductModal'
import ProductSortLayer from '../../components/product/ProductSortLayer'
import ProductSortModal from '../../components/product/ProductSortModal'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { IconArrowDown, IconArrowUp, IconCart, IconStarOn } from '../../components/svg/IconSvg'
import '../../css/Product.css'
import { formatNumberWithTruncation, plusComma } from '../../js/script'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../../components/provider/AppProvider'

// 이미지 경로
const imgURL = '/images'

export default function HotdealPage() {
  const [type, setType] = useState<string>('thumb')
  const [totalCount, setTotalCount] = useState<string>('') //상품 리스트 개수
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>()
  const [sortKeyword, setSortKeyword] = useState<string>('RECENT_PRODUCT') //정렬값
  const [sortKeywordLabel, setSortKeywordLabel] = useState<string>('최신순') //정렬 텍스트
  const [sortDirection, setSortDirection] = useState<string>('DESC') //정렬 내림차순?오름차순
  const [isSort, setIsSort] = useState<boolean>(false) //정렬 팝업열기
  const [isFilter, setIsFilter] = useState<boolean>(false) //필터 팝업열기
  const [getMax, setGetMax] = useState<number>(1000000)
  const [getMin, setGetMin] = useState<number>(0)
  const [filterMin, setFilterMin] = useState<number>(0)
  const [filterMax, setFilterMax] = useState<number>(1000000)
  const [max, setMax] = useState<number>(1000000)
  const [min, setMin] = useState<number>(0)
  const [freeCheck, setFreeCheck] = useState<boolean>(false)
  const [filterApply, setFilterApply] = useState<boolean>(false)
  const [brandArray, setBrandArray] = useState<any>([])
  const [items, setItems] = useState<any>([])
  const [isWishOk, setIsWishOk] = useState<boolean>(false)
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false)
  const [checkOptionOpen, setCheckOptionOpen] = useState<boolean>(false)
  const [checkCategoryNumber, setCheckCategoryNumber] = useState<any>()
  const [page, setPage] = useState<number>(1) //현재 페이지
  const { setIsLottie } = useCommonContext()

  const preventRef = useRef(true) //옵저버 중복 실행 방지
  const endRef = useRef(false) //모든 글 로드 확인
  const obsRef = useRef(null) //observer Element
  const btnSortRef = useRef<any>(null)

  useEffect(() => {
    getSearchCategory('핫딜').then((res) => {
      setCheckCategoryNumber(res.data.flatCategories[0]?.depth1CategoryNo)
    })
  }, [])

  useEffect(() => {
    //옵저버 생성
    const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 })
    if (obsRef.current) observer.observe(obsRef.current)
    return () => {
      observer.disconnect()
    }
  }, [])

  useEffect(() => {
    if (checkCategoryNumber) {
      preventRef.current = true
      getPost()
    }
  }, [page, checkCategoryNumber, type, sortDirection, sortKeyword, filterApply])

  const obsHandler = (entries: any) => {
    //옵저버 콜백함수
    const target = entries[0]
    if (!endRef.current && target.isIntersecting && preventRef.current) {
      //옵저버 중복 실행 방지
      preventRef.current = false //옵저버 중복 실행 방지
      setPage((prev) => prev + 1) //페이지 값 증가
    }
  }

  const getPost = useCallback(async () => {
    //글 불러오기

    try {
      getFilterList(
        sortKeyword,
        page,
        checkCategoryNumber,
        sortDirection,
        brandArray.join(','),
        getMin,
        getMax,
        freeCheck
      )
        .then((res) => {
          setItems((prev: any) => [...prev, ...res.data.items])
          if (res.data.pageCount <= page) {
            //마지막 페이지일 경우
            endRef.current = true
          }
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    } catch (e) {
      console.error(e)
    }
  }, [page])

  return (
    <>
      <div className='main_wrap'>
        <div className='contents_wrap'>
          <div className='page_title'>핫딜</div>
          <div className='product_list_wrap'>
            <div className='product_list_header'>
              <div className='product_list_num'>
                <span>{totalCount}</span>개의 상품
              </div>
              <ul className='product_list_option'>
                <li>
                  {isMobile ? (
                    <button
                      onClick={() => {
                        if (setIsSort) {
                          setIsSort(true)
                        }
                        setIsSortIcon(!isSortIcon)
                      }}
                    >
                      {sortKeywordLabel ? sortKeywordLabel : '정렬'}
                    </button>
                  ) : (
                    <>
                      <button
                        ref={btnSortRef}
                        onClick={() => {
                          if (setIsSort) {
                            setIsSort(true)
                          }
                          setIsSortIcon(!isSortIcon)
                        }}
                      >
                        {sortKeywordLabel ? sortKeywordLabel : '정렬'}
                        {isSortIcon ? (
                          <IconArrowUp width={12} height={12} color='var(--colBlack)' />
                        ) : (
                          <IconArrowDown width={12} height={12} color='var(--colBlack)' />
                        )}
                      </button>

                      {isSort
                        ? !isMobile && (
                            <ProductSortLayer
                              setIsModal={setIsSort}
                              setSortKeyword={setSortKeyword}
                              sortKeyword={sortKeyword}
                              setSortKeywordLabel={setSortKeywordLabel}
                              setSortDirection={setSortDirection}
                              sortDirection={sortDirection}
                              setIsSortIcon={setIsSortIcon}
                              btnSortRef={btnSortRef}
                            ></ProductSortLayer>
                          )
                        : null}
                    </>
                  )}
                </li>
                <li>
                  <button
                    onClick={() => {
                      if (setIsFilter) {
                        setIsFilter(true)
                        setFilterApply(false)
                      }
                    }}
                  >
                    필터
                  </button>
                </li>
                <li>
                  <button
                    className='btn_listtype'
                    onClick={() => {
                      if (type === 'thumb') {
                        setType('list')
                      } else {
                        setType('thumb')
                      }
                    }}
                  >
                    <img
                      src={type === 'thumb' ? `${imgURL}/icon_list.png` : `${imgURL}/icon_list_thumb.png`}
                      alt='상품보기 썸네일형'
                    />
                  </button>
                </li>
              </ul>
            </div>

            {brandArray || freeCheck || filterApply ? (
              items.length !== 0 ? (
                <div className={type === 'thumb' ? 'product_wrap thumb' : 'product_wrap list'}>
                  {items.map((el: any, idx: number) => {
                    return (
                      <ItemWrap
                        key={idx}
                        item={el}
                        type={type}
                        items={items}
                        idx={idx}
                        setIsWishOk={setIsWishOk}
                        setCheckOptionOpen={setCheckOptionOpen}
                        checkOptionOpen={checkOptionOpen}
                      />
                    )
                  })}
                </div>
              ) : (
                <div className='product_list_wrap'>
                  <div className='no_data'>
                    <p className='tit_txt'>상품이 없습니다.</p>
                    <p className='sub_txt'>선택한 필터를 변경해 보세요.</p>
                    <button
                      className='btn_black'
                      onClick={() => {
                        setBrandArray([])
                        setFreeCheck(false)
                        setGetMax(1000000)
                        setGetMin(0)
                        setFilterMax(1000000)
                        setFilterMin(0)
                        setFilterApply(false)
                      }}
                    >
                      필터 초기화
                    </button>
                  </div>
                </div>
              )
            ) : null}
          </div>
        </div>
      </div>

      {isModal ? (
        <ProductModal
          setIsModal={setIsModal}
          headerText={'옵션선택'}
          selectProductNo={selectProductNo}
          listItem={items}
        ></ProductModal>
      ) : null}
      {isSort
        ? isMobile && (
            <ProductSortModal
              headerText='정렬'
              setIsModal={setIsSort}
              setSortKeyword={setSortKeyword}
              sortKeyword={sortKeyword}
              setSortKeywordLabel={setSortKeywordLabel}
              setSortDirection={setSortDirection}
              sortDirection={sortDirection}
            ></ProductSortModal>
          )
        : null}
      {isFilter ? (
        isMobile ? (
          // <ProductFilterModal
          //   isCategoryModal={isFilter}
          //   setIsCategoryModal={setIsFilter}
          //   setFreeCheck={setFreeCheck}
          //   setGetMax={setGetMax}
          //   setGetMin={setGetMin}
          //   setFilterApply={setFilterApply}
          //   setBrandArray={setBrandArray}
          //   brandArray={brandArray}
          // ></ProductFilterModal>
          <ProductFilterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
            filterMax={filterMax}
            filterMin={filterMin}
            max={max}
            setMax={setMax}
            min={min}
            setMin={setMin}
          ></ProductFilterModal>
        ) : (
          <ProductFilterCenterModal
            isCategoryModal={isFilter}
            setIsCategoryModal={setIsFilter}
            setFreeCheck={setFreeCheck}
            setGetMax={setGetMax}
            setGetMin={setGetMin}
            setFilterApply={setFilterApply}
            setBrandArray={setBrandArray}
            brandArray={brandArray}
          ></ProductFilterCenterModal>
        )
      ) : null}
      <div ref={obsRef} style={{ height: '20px' }}></div>
    </>
  )
}

const ItemWrap = ({ item, type, setIsWishOk, items, idx, checkOptionOpen, setCheckOptionOpen }: any) => {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()
  const { hasAccessToken } = useCommonContext()

  const [optionlayer, setOptionLayer] = useState<boolean>(false)
  const [optionCheck, setOptionCheck] = useState<boolean>(false)
  const [optionItems, setOptionItems] = useState<any>([])
  // const [wish, setWish] = useState(false);
  const [disCountAcc, setDisCountAcc] = useState(0)

  useEffect(() => {
    if (optionlayer) {
      setOptionLayer(false)
      setOptionCheck(true)
    }
  }, [checkOptionOpen])

  useEffect(() => {
    if (item) {
      const count = formatNumberWithTruncation((item?.salePrice - item?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [item])
  return (
    <div
      className='product_item_wrap'
      // style={{
      //   paddingBottom: '16px',
      //   borderBottom:
      //     type !== 'thumb' && Number(idx + 1) === Number(items.length)
      //       ? '1px solid transparent'
      //       : '1px solid var(--colGray3)',
      // }}
    >
      <div className='product_image_area'>
        {type === 'thumb' && <LikeBtn item={item} />}
        <div className='item_flag'>
          <img src={`${imgURL}/icon_flag_outlet.svg`} alt='' />
        </div>
        <div
          onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
              })
            } else {
              navigate(`/product/${item.productNo}`)
            }
          }}
        >
          <div className='dim'></div>
          <img src={item.imageUrls[0]} alt='' />
        </div>
      </div>

      {type === 'thumb' ? (
        <>
          <BtnListCart item={item} type={type} />
          <div className='item_info_wrap'>
            <div
              className='product_item'
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
                  })
                } else {
                  navigate(`/product/${item.productNo}`)
                }
              }}
            >
              <div className='product_brand_title'>{item.brandName}</div>
              <div className='product_title'>{item.productName}</div>
              <div className='product_sale_price'>{plusComma(item.salePrice)}원</div>
              <div className='discounted_price'>
                <p className='percent'>{Math.floor((item.immediateDiscountAmt / item.salePrice) * 100)}%</p>
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
              {/* 최대혜택가 */}
              {!item?.accumulationUseInfo?.usable && !item.enableCoupons ? null : (item?.salePrice -
                item?.immediateDiscountAmt -
                item?.couponDiscountAmt -
                item?.accumulationInfo?.amount -
                item?.accumulationUseInfo?.usable
                  ? disCountAcc
                  : 0) === Number(item?.salePrice - item?.immediateDiscountAmt) ? null : (
                <div className='max_benefit'>
                  <p className='badge'>회원혜택가</p>
                  <p>
                    {plusComma(
                      (item?.salePrice -
                      item?.immediateDiscountAmt -
                      item?.couponDiscountAmt -
                      item?.accumulationInfo?.amount -
                      item?.accumulationUseInfo?.usable
                        ? disCountAcc
                        : 0) < 0
                        ? 0
                        : item?.salePrice -
                          item?.immediateDiscountAmt -
                          item?.couponDiscountAmt -
                          item?.accumulationInfo?.amount -
                          item?.accumulationUseInfo?.usable
                        ? disCountAcc
                        : 0
                    )}
                    원
                  </p>
                </div>
              )}

              {/* 페이백 적립금 5% + 추가적립금 */}
              {hasAccessToken && item?.accumulationInfo?.amount > 0 ? (
                <div className='save_mileage'>
                  <p>
                    {`페이백 적립금 ${item?.accumulationInfo.rewardRateOfProduct}% `}
                    {plusComma(item?.accumulationInfo?.amount)}
                    <img src={`${imgURL}/icon_point.png`} alt='' />
                  </p>
                </div>
              ) : null}

              {/* 별점 */}
              <div className='star_rating'>
                <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
                <span className='review_rating'>{item?.reviewRating}</span>
                <span className='review_num'>({item?.totalReviewCount})</span>
              </div>

              {/* 당일배송, 오늘만 특가 */}
              <div className='item_txt_flag'>
                <span className='delivery'>당일배송</span>
                <span className='today'>오늘만 특가</span>
              </div>
            </div>

            {/* 아울렛 옵션창 */}
            {/* <div className='option_wrap'>
              <button
                onClick={() => {
                  setCheckOptionOpen((prev: boolean) => !prev);
                  setTimeout(() => {
                    setOptionLayer(!optionlayer);
                  }, 10);
                }}
              >
                {optionlayer ? `옵션 닫기` : `옵션 보기`}
                {optionlayer ? (
                  <img
                    src={`${imgURL}/icon_arrow_up_gray_10.png`}
                    alt='옵션 닫기'
                  />
                ) : (
                  <img
                    src={`${imgURL}/icon_arrow_down_gray_10.png`}
                    alt='옵션 보기'
                  />
                )}
              </button>
              <div
                className={optionlayer ? `option_list on` : `option_list`}
                onMouseLeave={() => {
                  setOptionLayer(false);
                }}
              >
                <ul>
                  {optionItems.map((el: any) => {
                    return (div
                      <li className={el.stockCnt === 0 ? `soldout` : ``}>
                        <Link   onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
              })
            } else {
              navigate(`/product/${item.productNo}`)
            }
          }}>
                          <p>{el.value}</p>
                          <p className='quantity'>{el.stockCnt}개</p>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div> */}
          </div>
        </>
      ) : (
        <>
          <div className='item_info_wrap'>
            <div
              onClick={() => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
                  })
                } else {
                  navigate(`/product/${item.productNo}`)
                }
              }}
            >
              <div className='product_brand_title'>{item.productName}</div>
              <div className='product_title'>{item.productName}</div>
              <div className='product_sale_price'>{plusComma(item.salePrice)}원</div>
              <div className='discounted_price'>
                <p className='percent'>{Math.floor((item.immediateDiscountAmt / item.salePrice) * 100)}%</p>
                <p>{item.salePrice ? plusComma(item.salePrice - item.immediateDiscountAmt) : 0}원</p>
              </div>
              {/* 최대혜택가 */}
              {!item?.accumulationUseInfo?.usable && !item.enableCoupons ? null : (item?.salePrice -
                item?.immediateDiscountAmt -
                item?.couponDiscountAmt -
                item?.accumulationInfo?.amount -
                item?.accumulationUseInfo?.usable
                  ? disCountAcc
                  : 0) === Number(item?.salePrice - item?.immediateDiscountAmt) ? null : (
                <div className='max_benefit'>
                  <p className='badge'>회원혜택가</p>

                  <dd>
                    {plusComma(
                      (item?.salePrice -
                      item?.immediateDiscountAmt -
                      item?.couponDiscountAmt -
                      item?.accumulationInfo?.amount -
                      item?.accumulationUseInfo?.usable
                        ? disCountAcc
                        : 0) < 0
                        ? 0
                        : item?.salePrice -
                          item?.immediateDiscountAmt -
                          item?.couponDiscountAmt -
                          item?.accumulationInfo?.amount -
                          item?.accumulationUseInfo?.usable
                        ? disCountAcc
                        : 0
                    )}
                    원
                  </dd>
                </div>
              )}

              {/* 페이백 적립금 5% + 추가적립금 */}
              {hasAccessToken && item?.accumulationInfo?.amount > 0 ? (
                <div className='save_mileage'>
                  <p>
                    {`페이백 적립금 ${item?.accumulationInfo.rewardRateOfProduct}% `}
                    {plusComma(item?.accumulationInfo?.amount)}
                    <img src={`${imgURL}/icon_point.png`} alt='' />
                  </p>
                </div>
              ) : null}

              {/* 별점 */}
              <div className='star_rating'>
                <p>
                  <IconStarOn />
                </p>
                <p>{item.reviewRating}</p>
                <p className='review_num'>({item.totalReviewCount})</p>
              </div>

              {/* 당일배송, 오늘만 특가 */}
              <div className='item_txt_flag'>
                <span className='delivery'>당일배송</span>
                <span className='today'>오늘만 특가</span>
              </div>
            </div>
            {/* 아울렛 옵션창 */}
            <div className='option_wrap'>
              <button
                onClick={() => {
                  setOptionLayer(!optionlayer)
                }}
              >
                {optionlayer ? `옵션 닫기` : `옵션 보기`}
                {optionlayer ? (
                  <IconArrowUp color='var(--colGray6)' width={isMobile ? 10 : 16} height={isMobile ? 10 : 16} />
                ) : (
                  <IconArrowDown color='var(--colGray6)' width={isMobile ? 10 : 16} height={isMobile ? 10 : 16} />
                )}
              </button>
              <div className={optionlayer ? `option_list on` : `option_list`}>
                <ul>
                  {optionItems.map((el: any) => {
                    return (
                      <li key={`${el.value}-${el.stockCnt}`} className={el.stockCnt === 0 ? `soldout` : ``}>
                        <div
                          onClick={() => {
                            if (isAppView) {
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${item.productNo}`,
                              })
                            } else {
                              navigate(`/product/${item.productNo}`)
                            }
                          }}
                        >
                          <p>{el.value}</p>
                          <p className='quantity'>{el.stockCnt}개</p>
                        </div>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          </div>
          <div className='button_area'>
            <BtnListCart item={item} type={type} />
            <LikeBtn item={item} />
          </div>
        </>
      )}
    </div>
  )
}

// 장바구니 버튼
const BtnListCart = ({ item, type }: any) => {
  const [isModal, setIsModal] = useState(false)

  return (
    <>
      <button
        className='btn_cart'
        onClick={() => {
          setIsModal(true)
        }}
      >
        <IconCart color='var(--colBlack)' width={20} height={20} />
        {/* 장바구니 텍스트 보이기  */}
        {type === 'list' && isMobile ? null : '장바구니'}
      </button>

      {isModal ? (
        isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            listItem={item}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={item.productNo}
            listItem={item}
          ></ProductCenterModal>
        )
      ) : null}
    </>
  )
}

const BtnListWish = ({ item, setIsWishOk }: any) => {
  const [isWish, setIsWish] = useState(false)
  useEffect(() => {
    setIsWish(item.liked)
  }, [item])
  return (
    <button
      className='btn_like'
      onClick={() => {
        const likeItem = { like: !isWish ? 'Y' : 'N', productNo: item.productNo }

        postLikeProducts(likeItem)
          .then(() => {
            setIsWishOk((prev: boolean) => !prev)
          })
          .catch((err) => console.log(err))
      }}
    >
      {isWish ? (
        <img src={`${imgURL}/icon_heart_fill.png`} alt='찜하기 아이콘' />
      ) : (
        <img src={`${imgURL}/icon_heart_outline.png`} alt='찜하기 아이콘' />
      )}
    </button>
  )
}
